/** @module csi/canvas/PagesRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/heading/RefContainer",
	"csi/locale",
	"csi/widget/MaterialIconWithLabel"
], function(declare, _, RefContainer, locale, MaterialIconWithLabel) {

	return declare(RefContainer, {
		/**
		 * @override
		 * If any snapshots are missing, then render error message 
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var nodes = this.getReferencedNodes(ctx, h);

			if (_.findWhere(nodes, {ThumbnailGenerated: false})) {
				new MaterialIconWithLabel({
					icon: "error",
					iconSize: 20,
					label: locale.resource("CanvasThumbnailMissing")
				}).placeAt(refNode);
				return true;
			}

			return this.inherited(arguments);
		}
	});
});
